import * as React from 'react'
import ReactDOM from 'react-dom'

type PropsType = {
  children: React.ReactNode
}

/* eslint-disable @typescript-eslint/member-ordering */
export default class Portal extends React.PureComponent<PropsType> {
  root: HTMLBodyElement | null | undefined

  el: HTMLDivElement

  constructor(props: PropsType) {
    super(props)

    // eslint-disable-next-line fp/no-mutation
    this.root = document.body as HTMLBodyElement
    this.el = document.createElement('div')
  }

  componentDidMount() {
    if (this.root) {
      this.root.appendChild(this.el)
    }
  }

  componentWillUnmount() {
    if (this.root) {
      // https://stackoverflow.com/questions/18919560/object-doesnt-support-property-or-method-remove/36303401
      this.el.parentElement.removeChild(this.el)
    }
  }

  render() {
    return ReactDOM.createPortal(this.props.children, this.el)
  }
}
/* eslint-enable @typescript-eslint/member-ordering */
